import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=629c4298&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=629c4298&prod&scoped=true&lang=css"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&id=629c4298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c4298",
  null
  
)

export default component.exports